import { render, staticRenderFns } from "./ActionsHistory.vue?vue&type=template&id=48988032&scoped=true"
import script from "./ActionsHistory.vue?vue&type=script&lang=js"
export * from "./ActionsHistory.vue?vue&type=script&lang=js"
import style0 from "./ActionsHistory.vue?vue&type=style&index=0&id=48988032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48988032",
  null
  
)

export default component.exports